import { useState, useEffect } from 'react'
import { Box, Grid, List, ListItem, ListItemText, Collapse, Typography, Popover, makeStyles } from '@material-ui/core'
import { ExpandLess, ExpandMore, ArrowBackIos as ArrowBackIosIcon } from '@material-ui/icons'

import FaqIcon from 'images/icons/FaqIcon'
import logoMutualMobile from 'images/logo-only.png'
import { getFromApi } from 'actions'
import { useApiRequest } from 'utils/customHooks/useApiRequest'

const useStyles = makeStyles(() => ({
   circleQuestions: {
      // backgroundColor: '#2a5ac1',
      background: 'linear-gradient(128deg, rgba(51,97,196,1) 0%, rgba(26,74,149,1) 78%)',
      cursor: 'pointer',
      borderRadius: '50%',
      width: '60px',
      height: '60px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      //   margin: '0 4rem 1rem auto',
      position: 'absolute',
      bottom: '7%',
      right: '5%',
      border: 'none'
   },
   rootPopover: {
      maxHeight: '86%'
   },
   paperPopover: {
      height: 'auto'
   },
   popoverContainer: {
      display: 'flex',
      // flex: '1 1 auto',
      width: '300px',
      height: '450px',
      flexDirection: 'column',
      gap: '.5rem'
   },
   boxPopoverHeader: {
      backgroundColor: '#13427f',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: 'white',
      padding: '.3rem 1rem'
   },
   logoMobile: {
      width: '20px',
      alignSelf: 'center',
      backgroundColor: 'white',
      borderRadius: '50%'
   },
   questionsContainer: {
      overflowY: 'auto',
      scrollbarWidth: 'thin !important'
   }
}))

const FaqList = () => {
   const classes = useStyles()
   const [data, setFrequentQuestions] = useState([])
   const [open, setOpen] = useState([])
   const [anchorEl, setAnchorEl] = useState(null)

   const openPopover = Boolean(anchorEl)
   const id = openPopover ? 'simple-popover' : undefined

   const handleOpen = event => {
      setAnchorEl(event.currentTarget)
   }

   const handleClose = () => {
      setAnchorEl(null)
   }

   async function _getAllFrequentQuestions() {
      const url = `${process.env.REACT_APP_LOGIN_API}/users/faq`
      const dataResponse = await getFromApi(url)
      setFrequentQuestions(dataResponse)
      setOpen(Array(dataResponse?.length).fill(false))
   }

   const getAllFrequentQuestions = useApiRequest(
      _getAllFrequentQuestions,
      'Preguntas Frecuentes: Consultar roles and grupos'
   )

   const handleClick = index => {
      const newOpen = [...open]
      if (!newOpen[index]) newOpen.fill(false)
      newOpen[index] = !newOpen[index]
      setOpen(newOpen)
   }

   useEffect(() => {
      getAllFrequentQuestions()
   }, [])

   return (
      <>
         <button className={classes.circleQuestions} onClick={handleOpen}>
            <FaqIcon color="#F9FAFC" />
         </button>
         <Popover
            id={id}
            open={openPopover}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
               vertical: 'top',
               horizontal: 'center'
            }}
            transformOrigin={{
               vertical: 'bottom',
               horizontal: 'right'
            }}
            style={{ marginBottom: '10px' }}
            classes={{
               root: classes.rootPopover,
               paper: classes.paperPopover
            }}
         >
            <Grid className={classes.popoverContainer}>
               <Box className={classes.boxPopoverHeader}>
                  <Box style={{ display: 'flex', gap: '1rem' }}>
                     <img src={logoMutualMobile} alt="Logo MutualSer" className={classes.logoMobile} />
                     <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>Preguntas frecuentes</Typography>
                  </Box>

                  <div
                     style={{
                        backgroundColor: '#0d2d57',
                        borderRadius: '50%',
                        padding: '.2rem',

                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                     }}
                     onClick={() => setAnchorEl(null)}
                  >
                     <ArrowBackIosIcon
                        style={{
                           fontSize: '12px',
                           margin: '.2rem .1rem .2rem .3rem'
                        }}
                     />
                  </div>
               </Box>
               <Box style={{ padding: '0rem 1rem' }}>
                  <div
                     style={{
                        backgroundColor: '#f7f7f7',
                        padding: '.4rem .7rem',
                        borderRadius: '15px'
                     }}
                  >
                     <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                        Identifícate en Mutual SER
                     </Typography>
                  </div>
               </Box>
               <Grid container className={classes.questionsContainer}>
                  <List>
                     {data.map((item, index) => (
                        <div key={index}>
                           <ListItem
                              button
                              onClick={() => handleClick(index)}
                              style={{ background: open[index] ? '#eee' : 'transparent' }}
                           >
                              <ListItemText
                                 primary={
                                    <Typography
                                       style={{
                                          fontSize: '10px',
                                          fontWeight: 'bold',
                                          width: '90%'
                                       }}
                                    >
                                       {item.question}
                                    </Typography>
                                 }
                              />
                              <div className={classes.circleItem}>{open[index] ? <ExpandLess /> : <ExpandMore />}</div>
                           </ListItem>
                           <Collapse in={open[index]} timeout="auto" unmountOnExit>
                              <List component="div" disablePadding>
                                 <ListItem>
                                    <ListItemText
                                       primary={
                                          <p
                                             style={{ fontSize: '10px', lineBreak: 'anywhere' }}
                                             dangerouslySetInnerHTML={{
                                                __html: item.answer
                                             }}
                                          ></p>
                                       }
                                    />
                                 </ListItem>
                              </List>
                           </Collapse>
                        </div>
                     ))}
                  </List>
               </Grid>
            </Grid>
         </Popover>
      </>
   )
}

export default FaqList
